const HomePage = () => {
  return (
    <>
      <section className="hero">
        <div className="content-wrap">
          <h2>Moving your business higher!</h2>
          <h3>
            Are you looking for mechanical engineering design support to launch
            your next product or to improve the manufacturing of the existing
            lines? Or maybe you just want to automate repetitive tasks that take
            up your valuable time? Contact us now for a free consultation.
          </h3>
          <h3>
            bluEggDev provides design support and custom business automation
            solutions. We aim to help your business grow without having to hire
            additional staff. Do what you love!
          </h3>
          <h2>Services include:</h2>
          <ul>
            <li>
              development of concepts and 3D models managed through your PDM
            </li>
            <li>
              component design and selection including sensors, motors,
              gearboxes, belts, pulleys, pneumatic cylinders and valves
            </li>
            <li>
              analyses for kinematics, stress, stiffness, vibration, thermal,
              GD&T and tolerance stack-ups
            </li>
            <li>
              production documention including drawing packages, bill of
              materials (BOM) and assembly/test procedures
            </li>
            <li>experimental validation support</li>
            <li>
              advice on best practices for design, document preparation, and
              process flow with PDM and ERP systems
            </li>
            <li>programming business automation solutions</li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default HomePage;
